import { render } from "./institution-template.vue?vue&type=template&id=9ce83484&scoped=true"
import script from "./institution-template.vue?vue&type=script&lang=js"
export * from "./institution-template.vue?vue&type=script&lang=js"

import "./institution-template.vue?vue&type=style&index=0&id=9ce83484&lang=scss&scoped=true"

import exportComponent from "/usr/local/apps/meng/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ce83484"]])

export default __exports__